import { useAuthQuery } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';
import { AdminsApi } from 'api';
import { SearchAdminQueryType } from 'types';

function useGetAll(query: SearchAdminQueryType) {
  return useAuthQuery(
    getQueryKeys([KEY]).list({ ...query }),
    () => AdminsApi.getAll(query),
    {
      select: (data) => data.data,
    },
  );
}

export default useGetAll;
